import Collapse from './Collapse';
import Paper from './Paper';
import Section from './Section';
import Array from './Array';
import Divider from './Divider';

export default {
    Collapse,
    Paper,
    Section,
    Array,
    Divider,
};
